// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
// ── Default Preference Values ──
export const DEFAULT_NOTIFICATION_PREFERENCES = {
    channels: {
        task_assigned: { platform: true, email: true },
        task_sla_approaching: { platform: true, email: true },
        task_overdue: { platform: true, email: true },
        task_completed: { platform: true, email: false },
        task_escalated: { platform: true, email: true },
        workflow_transition: { platform: true, email: false },
        approval_requested: { platform: true, email: true },
        comment_added: { platform: true, email: false },
        weekly_digest: { platform: false, email: true },
        sla_breach_report: { platform: true, email: true },
        system_alert: { platform: true, email: true },
    },
    quiet_hours_enabled: false,
    digest_frequency: 'weekly',
    watched_entities: [],
};
//# sourceMappingURL=notification.js.map